import { $api } from "../generated/client";

export interface ItemInActiveReturn {
	lineItemId: string;
	quantity: number;
	returnRequestId: string;
	returnRequestName: string;
}

export interface GetItemsInActiveReturnsResponse {
	itemsInOtherReturns: ItemInActiveReturn[];
}

interface UseGetItemsInActiveReturnsParams {
	shopId: string;
	returnRequestId: string;
	enabled?: boolean;
}

export default function useGetItemsInActiveReturns(
	params: UseGetItemsInActiveReturnsParams,
) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/return-requests/{returnRequestId}/items-in-active-returns",
		{
			params: {
				path: {
					shopId: params.shopId,
					returnRequestId: params.returnRequestId,
				},
			},
		},
		{
			enabled: params.enabled !== false,
			staleTime: 30000,
		},
	);
}
